// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"159":"5acd441a2cdeea37c7c1","339":"bed09e6ad93ab0a6da18"}[chunkId] + ".js";
};